// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__kDyy0","textarea":"MessageSender_textarea__FqN08","button":"MessageSender_button__3qULl"};